import type { SVGProps } from 'react';
import * as React from 'react';
const SvgIconUnmarked = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 13.196c0-.917.746-1.479 2.06-2.358 1.22-.815 1.864-1.872 1.578-3.311-.286-1.44-1.475-2.629-2.914-2.915-2.26-.45-4.433 1.335-4.433 3.638M12 19.5v-1.499"
    />
  </svg>
);
export default SvgIconUnmarked;
